import { updateField } from 'vuex-map-fields';

export default {
  START_LOADING_ORGANISATION_CONTACT_TAGS(state) {
    state.loading = true;
  },
  SET_ORGANISATION_CONTACT_TAGS(state, payload) {
    state.list = payload;
    state.loading = false;
  },
  // APPEND_ORGANISATION_CONTACT_TAGS(state, payload) {
  //   if (payload) {
  //     state.list.push(payload);
  //   }
  // },
  // DELETE_TAG(state, removeId) {
  //   state.list = state.list.filter(tag => tag.id !== removeId);
  // },
  // UPDATE_TAG(state, payload) {
  //   const targetTag = state.list.find(tag => tag.id === payload.tagId);
  //   targetTag.name = payload.data.name;
  // },
  // ADD_TAG_TO_USER(state, payload) {
  //   console.log('MUTATION', payload);
  // },
  API_ERROR(state, payload) {
    if (payload) {
      state.apiError = payload;
      state.loading = false;
    }
  },
  updateField,
};
